export default __webpack_public_path__ + "static/media/cancellations.34b36894.svg";